export const getMaskByCountryCode = (code: string) => {
  switch (code.toUpperCase()) {
    case "BR":
      return "(99) 99999-9999";
  }
  return "";
};
